import { IPromotionDetailRequest, IPromotionParams, TPromotionIdentifier } from 'core/model/interfaces/promotions';
import { promotionsData } from './promotions.data';
import {
  mapPromotionDetailDomainToDto,
  mapPromotionDetailDtoToDomain,
  mapPromotionListDtoToDomain,
  mapPromotionParamsDomainToDto,
  toPromotionForAutocompleteList,
} from './promotions.mapper';

export const promotionsService = {
  getPromotionSummaryList: async () => {
    const response = await promotionsData.getPromotionSummaryList();
    return toPromotionForAutocompleteList(response);
  },
  getPromotionList: async (params: IPromotionParams) => {
    const response = await promotionsData.getPromotionList(mapPromotionParamsDomainToDto(params));
    return mapPromotionListDtoToDomain(response);
  },
  getPromotionDetail: async (identifier: TPromotionIdentifier) => {
    const response = await promotionsData.getPromotionDetail(identifier);
    return mapPromotionDetailDtoToDomain(response);
  },
  updatePromotion: async (identifier: TPromotionIdentifier, body: IPromotionDetailRequest) => {
    await promotionsData.updatePromotion(identifier, mapPromotionDetailDomainToDto(body));
  },
};
